import { Link } from 'react-router-dom';
import { Ruler } from 'lucide-react';

export default function Footer() {
  return (
    <footer role="contentinfo" aria-label="Site footer" className="bg-[#1C1917] text-[#E8E2D9] mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Ruler className="w-5 h-5 text-[#C5A028]" />
              <span className="font-['Cormorant_Garamond'] text-lg font-bold text-white">TrueFitGuide</span>
            </div>
            <p className="text-sm text-[#78716C] leading-relaxed">Free clothing size converter and fit finder for 50+ global brands. Find your perfect fit before you buy.</p>
          </div>
          <div>
            <h4 className="font-['Cormorant_Garamond'] text-white font-semibold mb-4">Tools</h4>
            <div className="flex flex-col gap-2 text-sm">
              <Link to="/find-my-size" className="hover:text-[#C5A028] transition-colors">Find My Size</Link>
              <Link to="/compare" className="hover:text-[#C5A028] transition-colors">Compare Sizes</Link>
              <Link to="/brands" className="hover:text-[#C5A028] transition-colors">All Brands</Link>
              <Link to="/body-type-guide" className="hover:text-[#C5A028] transition-colors">Body Type Guide</Link>
            </div>
          </div>
          <div>
            <h4 className="font-['Cormorant_Garamond'] text-white font-semibold mb-4">Resources</h4>
            <div className="flex flex-col gap-2 text-sm">
              <Link to="/blog" className="hover:text-[#C5A028] transition-colors">Blog</Link>
              <Link to="/disclaimer" className="hover:text-[#C5A028] transition-colors">Disclaimer</Link>
              <Link to="/privacy" className="hover:text-[#C5A028] transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-[#C5A028] transition-colors">Terms of Service</Link>
              <Link to="/accessibility" className="hover:text-[#C5A028] transition-colors">Accessibility</Link>
            </div>
          </div>
          <div>
            <h4 className="font-['Cormorant_Garamond'] text-white font-semibold mb-4">Regions We Cover</h4>
            <div className="flex flex-wrap gap-2 text-xs">
              {['US','UK','EU','Japan','Korea','Australia','France','Italy','Germany','Spain'].map(r => (
                <span key={r} className="bg-[#2A2926] px-2 py-1 rounded">{r}</span>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-10 pt-8 border-t border-[#2A2926] flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#78716C]">&copy; {new Date().getFullYear()} TrueFitGuide. All rights reserved. Not affiliated with any brand.</p>
          <p className="text-xs text-[#78716C]">Sizes are approximate. Always verify with the retailer.</p>
        </div>
      </div>
    </footer>
  );
}
